import h5Layout from '@/views/h5/index.vue'
export const h5Router = [
    {
        path: '/h5',
        name: 'h5',
        component: h5Layout,
        children:[
            {
                // 测试用页面
                path: '/h5/test',
                name: 'h5-test',
                component: () => import('@/views/h5/test/index.vue')
            },
            {
              // hrm面试报告
              path: '/h5/hrmInterviewReport',
              name: 'HrmInterviewReport',
              component: () => import('@/views/h5/hrmInterviewReport/index.vue'),
              meta: { title: '面试报告' }
            },
            {
                // 小程序跳转入入口
                path: '/h5/jumpCenter',
                name: 'h5-jumpCenter',
                component: () => import('@/views/h5/jumpCenter/index.vue')
            },
            {
                // 错题统计主页面
                path: '/h5/errorStatist',
                name: 'h5ErrorStatist',
                component: () => import('@/views/h5/errorStatist/index.vue'),
                meta: {
                    title: '错题统计',
                    keepCase: ['h5ByQaClass', 'h5ErrStatistDetail']
                }
            },
            {
                // 错题统计--按题目展示班级列表
                path: '/h5/byQaClass',
                name: 'h5ByQaClass',
                component: () => import('@/views/h5/errorStatist/ByQaClass.vue'),
                meta: { title: '错题统计' }
            },
            {
                // 错题统计--按题目展示班级列表
                path: '/h5/errStatistDetail',
                name: 'h5ErrStatistDetail',
                component: () => import('@/views/h5/errorStatist/ErrStatistDetail.vue'),
                meta: { title: '错题统计' }
            },
            {
                // h5直播课巡课
                path: '/h5/liveMonitor',
                name: 'h5LiveMonitor',
                component: () => import('@/views/h5/liveMonitor/index.vue'),
                meta: { title: '直播课巡课' }
            },
            {
                // 女性公益财税培训
                path: '/h5/form',
                name: 'h5Form',
                component: () => import('@/views/h5/form/index.vue'),
                meta: { title: '女性公益财税培训' }
            },
          {
            // 仁和新年音乐会
            path: '/h5/newYearConcert',
            name: 'NewYearConcert',
            component: () => import('@/views/h5/form/newYearConcert.vue'),
            meta: { title: '仁和新年音乐会' }
          },
          {
            // AI启航
            path: '/h5/aiQiHang',
            name: 'AiQiHang',
            component: () => import('@/views/h5/form/aiQiHang.vue'),
            meta: { title: '智慧赋能AI启航' }
          },
          {
            // 3D打印
            path: '/h5/print3D',
            name: 'Print3D',
            component: () => import('@/views/h5/form/print3D.vue'),
            meta: { title: '3D打印亲子创造营报名' }
          },
            {
                // 跳转小程序跳转页
                path: '/h5/jumpMini',
                name: 'h5-jumpMini',
                component: () => import('@/views/h5/jumpMini/index.vue')
            },
        ]
    }
]
